<form class="xr-auth-stack" [formGroup]="password_reset_form" (ngSubmit)="onSubmit()" #password_reset_form_dir="ngForm">
  <div>
    <h1 class="xr-auth-title">{{ "recovery_password.title" | translate }}</h1>
    <p class="xr-auth-subtitle">{{ "recovery_password.enter_email_account" | translate }}</p>
  </div>

  <div class="xr-auth-field">
    <label class="xr-auth-label" for="recovery-email">{{ "recovery_password.email_address" | translate }}</label>
    <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
      <input matInput type="email" id="recovery-email" formControlName="email" autocomplete="email"
             [placeholder]="'login.email_placeholder' | translate"/>
      <mat-error *ngIf="emailFormControl?.hasError('required') && (emailFormControl?.touched || password_reset_form_dir.submitted)">
        {{ 'login.email_required' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <button type="submit" class="xr-btn xr-btn--primary xr-auth-submit" [disabled]="!password_reset_form.valid">
    {{ "recovery_password.send_link" | translate }}
  </button>
  <a [routerLink]="['/login']" class="xr-auth-link">
    <span aria-hidden="true">←&nbsp;</span>{{ "recovery_password.back_login" | translate }}
  </a>
</form>
